import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  InputLabel,
  Button,
} from '@mui/material'
import { useTranslate, useNotify } from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import LoadingButton from '@mui/lab/LoadingButton'
import { supplierConciliationServices } from 'src/services/purchases/supplier_conciliation/supplierConciliation.service'

export const ChangeConciliationStatusDialog = ({
  open,
  setOpen,
  currentStatus,
  conciliationId,
  onSuccess,
}) => {
  const notify = useNotify()
  const translate = useTranslate()
  const [isLoading, setIsLoading] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState('OPEN')

  useEffect(() => {
    if (open) {
      if (['OPEN', 'CLOSED', 'DELETED'].includes(currentStatus)) {
        setSelectedStatus(currentStatus)
      } else {
        setSelectedStatus('OPEN')
      }
    }
  }, [open, currentStatus])

  const statusOptions = [
    {
      id: 'OPEN',
      label: translate('ra.status.OPEN') || 'ABIERTA',
    },
    {
      id: 'CLOSED',
      label: translate('ra.status.CLOSED') || 'CERRADA',
    },
    {
      id: 'DELETED',
      label: translate('ra.status.DELETED_FEM') || 'ELIMINADA',
    },
  ]

  const onSubmit = async () => {
    setIsLoading(true)
    try {
      await supplierConciliationServices.updateConciliation(Number(conciliationId), {
        general_status: selectedStatus,
      })
      setOpen(false)
      if (onSuccess) {
        await onSuccess()
      }
      notify('ra.notification.updated_success_masculine', {
        type: 'success',
        messageArgs: { element: translate('ra.field.status') || 'Estado' },
      })
    } catch (error) {
      console.error(error)
      notify('ra.message.update_status_error', { type: 'error' })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth='xs'>
      <DialogTitle>{translate('ra.title.update_status') || 'Modificar estado'}</DialogTitle>
      <DialogContent>
        <InputLabel id='conciliation-status-label' sx={{ mb: 1, fontSize: '14px' }}>
          {translate('ra.field.status') || 'Estado'}
        </InputLabel>
        <Select
          id='conciliation-status'
          fullWidth
          value={selectedStatus}
          size='small'
          onChange={(e) => setSelectedStatus(e.target.value)}
        >
          {statusOptions.map((option) => (
            <MenuItem value={option.id} key={option.id}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          margin: '15px 24px',
        }}
      >
        <LoadingButton
          loading={isLoading}
          variant='contained'
          startIcon={<SaveIcon />}
          onClick={onSubmit}
        >
          {translate('ra.action.save') || 'Guardar'}
        </LoadingButton>
        <Button onClick={() => setOpen(false)} variant='outlined' color='error'>
          {translate('ra.action.cancel') || 'Cancelar'}
        </Button>
      </div>
    </Dialog>
  )
}
